module.exports = __webpack_public_path__ + "img/credits.be86343d.png";